import type { CSSProperties } from "react";

/**
 * GenArtBackground — vertical gradient matching the iOS
 * `GenArtBackground` (0x14101C → 0x05040A). The gradient is pinned to the
 * viewport so the hero artwork can fade into the scene edge.
 *
 * Source: `Artist/Features/GenArt/Views/GenArtView.swift` → `fixedScene`.
 */
export function GenArtBackground({
	style,
}: Readonly<{ style?: CSSProperties }>) {
	return (
		<div
			aria-hidden="true"
			style={{
				position: "absolute",
				inset: 0,
				overflow: "hidden",
				background:
					"linear-gradient(to bottom, #14101C 0%, #0a0815 55%, #05040A 100%)",
				...style,
			}}
		/>
	);
}
